<template>
  <div class="top-nav d-print-none">
    <div class="d-flex align-items-center">
      <img
        src="/assets/images/hey-marvelous-logo-mobile.svg"
        class="icon mr-2 d-md-none"
      />
      <span v-if="title && !hideTitleOnMobile" class="h5 m-0 d-md-none">{{
        title
      }}</span>
      <span v-if="title" class="h3 d-none d-md-block">{{ title }}</span>

      <span class="back-button pl-1 pointer" v-if="!title" @click="goBack">
        <i class="fal fa-chevron-left pr-3"></i>
        <span class="d-none d-md-inline-block">{{
          $t('GENERAL.LINK.NAVIGATE_BACK')
        }}</span>
      </span>
    </div>
    <div class="d-flex align-items-center">
      <div class="nav-content">
        <slot></slot>
      </div>
      <div
        class="open-main-nav-button d-md-none"
        v-if="showOpenMainNav"
        @click="openMainNav"
      >
        <font-awesome-icon :icon="['far', 'bars']" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    showOpenMainNav: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Array,
      default: null,
    },
    hideTitleOnMobile: {
      type: Boolean,
      default: false,
    },
    backRouteName: {
      type: String,
      default: null,
    },
  },
  methods: {
    openMainNav() {
      this.$store.dispatch('globals/openMainNav');
    },
    goBack() {
      if (this.backRouteName) {
        this.$router.push({ name: this.backRouteName });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.top-nav {
  display: flex;
  border-bottom: 1px solid $medium-gray;
  justify-content: space-between;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
  padding-top: 0.5rem;
  margin-top: -0.5rem;
  position: sticky;
  top: 0;
  z-index: 8;
  background-color: $white;
}

.nav-content {
  display: flex;
}

.h3 {
  margin: 0;
}

.pointer {
  cursor: pointer;
}

.back-button {
  &:hover {
    color: $coral;
  }
}

.open-main-nav-button {
  width: 42px;
  text-align: center;
  cursor: pointer;
  &:hover,
  &:active {
    color: $coral;
  }
}
</style>
